import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { useTranslate } from "localization";
import { Button } from "minimum-ui/core";

import { selectors } from "./slice";

const ResetAll: React.FC<{ ignoreParams?: string }> = ({ ignoreParams }) => {
  const { translate } = useTranslate();
  const [query, setQuery] = useSearchParams();
  const hasFilters = useSelector(selectors.hasFilters);

  const handleReset = () => {
    if (ignoreParams) {
      const selectParams = query.get(ignoreParams);
      const newParams = new URLSearchParams();

      if (selectParams) {
        newParams.set(ignoreParams, selectParams);
      }
      setQuery(newParams);
    } else {
      setQuery({});
    }
  };
  return hasFilters ? (
    <Button onClick={handleReset}>{translate("reset")}</Button>
  ) : null;
};

export default ResetAll;
